export default "__VITE_ASSET__BxZsnOwU__"